module.exports = __webpack_public_path__ + "static/infrared_homepage_loop-84eb4af1760f8a3fd9eb93114cf3cb49.mp4";